module.exports = __webpack_public_path__ + "img/canbadge_star_w56mm_trimmark.8abab53e.png";